export default "__VITE_ASSET__Bxyv3zw$__"